
        var result = require("!!../../../node_modules/css-loader/index.js!./fees.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/fees/fees.component.css
// module id = 436
// module chunks = 2